module.exports = __webpack_public_path__ + "assets/back-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/back-btn-icon.svg
// module id = 807
// module chunks = 0